import { computed, toValue } from "vue";
import { useComponentVariableSearchableStore } from "..";
export const useComponentVariableSearchables = (componentId) => {
    const componentVariableSearchableStore = useComponentVariableSearchableStore();
    const componentVariableSearchables = computed(() => {
        const componentIdValue = toValue(componentId);
        if (!componentIdValue) {
            return [];
        }
        return componentVariableSearchableStore.getComponentVariableSearchables(componentIdValue);
    });
    return {
        componentVariableSearchables,
    };
};
